import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { CardNameWrapper } from 'site-modules/shared/components/comparator/comparator-header/card-name';

export function CarName({
  year = '',
  makeName = '',
  modelName = '',
  makeSlug = '',
  modelSlug = '',
  submodelSlug = '',
  styleName = '',
  columnName,
  removeVehicle = null,
  titleClassName,
  nameClassName,
}) {
  const onRemove = useCallback(() => {
    removeVehicle({ name: columnName });
  }, [columnName, removeVehicle]);

  if (!(makeSlug && modelSlug && year)) {
    return null;
  }

  const link = {
    text: `${year} ${makeName} ${modelName}`,
    url: getCoreUrl({ makeSlug, modelSlug, submodelSlug, year }),
  };

  return (
    <CardNameWrapper
      link={link}
      onRemove={onRemove}
      nameText={styleName}
      hideRemoveButton={!removeVehicle}
      titleClassName={titleClassName}
      nameClassName={nameClassName}
    />
  );
}

CarName.propTypes = {
  columnName: PropTypes.string.isRequired,
  removeVehicle: PropTypes.func,
  year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  makeName: PropTypes.string,
  modelName: PropTypes.string,
  makeSlug: PropTypes.string,
  modelSlug: PropTypes.string,
  submodelSlug: PropTypes.string,
  styleName: PropTypes.string,
  titleClassName: PropTypes.string,
  nameClassName: PropTypes.string,
};
